module.exports = __webpack_public_path__ + "img/07.6085a127.jpeg";